import { unlabeled } from '../../entities';
import type { RoiFilterStep, RoiFilterStrategyContext } from './roi-filter.types';

export function applyUnlabeledFilter(step: RoiFilterStep, ctx: RoiFilterStrategyContext): Set<string> | undefined {
  const unlabeledRoisSet = ctx.labelIndex.get(unlabeled) ?? new Set();
  const filteredRoiIds = Array.from(ctx.previousRoiIds).filter((id) =>
    step.value === 'true' ? unlabeledRoisSet.has(id) : !unlabeledRoisSet.has(id)
  );
  return new Set(filteredRoiIds);
}
